import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import {FormGroup, FormControl} from '@angular/forms';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'fury-analytics-list',
  templateUrl: './analytics-list.component.html',
  styleUrls: ['./analytics-list.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AnalyticsListComponent implements OnInit {

  today = new Date();
  month = this.today.getMonth();
  year = this.today.getFullYear();
  startDate:string = moment().subtract(30, "days").format("YYYY-MM-DD HH:mm:ss");
  endDate:string = moment(this.today).format('YYYY-MM-DD HH:mm:ss');
  selectConfig = {disableOptionCentering: true,panelClass: 'custom-class'}
  columns: any = [];
  uniqueUsersColums = [
    {name: 'Session Id', property: 'sessionId', visible: true},
    {name: 'Total Page Visits', property: 'totalPageVisits', visible: true},
    { name: 'Actions', property: 'actions', visible: true },
  ]
  
  allPageVisitColums = [
    {name: 'Browser Info', property: 'browserInfo', visible: true},
    {name: 'Os Info', property: 'osInfo', visible: true},
    {name: 'Ip Address', property: 'ipAddress', visible: true},
    {name: 'City', property: 'city', visible: true},
    {name: 'Country', property: 'country', visible: true},
    {name: 'Utm Source', property: 'utmSource', visible: true},
    {name: 'Internal Url', property: 'internalUrl', visible: true},
    {name: 'Referral Url', property: 'referralUrl', visible: true},
    // { name: 'Actions', property: 'actions', visible: true },
  ];
  conversionsColumn = [
    {name: 'Added On', property: 'addedOn', visible: true},
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Email Address', property: 'emailAddress', visible: true},
    {name: 'Mobile Number', property: 'mobileNumber', visible: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'Sold Amount', property: 'soldAmount', visible: true},
  ];
  soldLeadsColumn = [
    {name: 'Added On', property: 'addedOn', visible: true},
    {name: 'First Name', property: 'firstName', visible: true},
    {name: 'Last Name', property: 'lastName', visible: true},
    {name: 'Email Address', property: 'emailAddress', visible: true},
    {name: 'Mobile Number', property: 'mobileNumber', visible: true},
    {name: 'Source', property: 'source', visible: true},
    {name: 'Sold Amount', property: 'soldAmount', visible: true},
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  itemList: any;
  filterValue: any;
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  searchedKeyword!: string;
  analyticsDetails: any;
  campaignOne = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  campaignTwo = new FormGroup({
    start: new FormControl(new Date(this.year, this.month, 15)),
    end: new FormControl(new Date(this.year, this.month, 19)),
  });
  tabName : string = 'uniqueUsers';
  listTitle !: string;
 
  constructor(
    private apiservice: ApiService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  
    this.filterValue = 'Analytics';
    this.router.onSameUrlNavigation = 'reload';

    this.activatedRoute.queryParams.subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.searchedKeyword = res.keywords ? res.keywords : '';
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
      this.tabName = res.tabName ? res.tabName : 'uniqueUsers';
      this.getAnalyticsData();
      this.getTabData();
    });
  }
  get visibleColumns() {
    return this.columns
      .filter((column: any) => column.visible)
      .map((column :any) => column.property);
  }
  ngOnInit(): void { }

  ngAfterViewInit(): void {
    if(this.tabName == 'uniqueUsers'){
      this.columns = this.uniqueUsersColums;
    } else if(this.tabName == 'conversions'){
      this.columns = this.conversionsColumn;
    } else if (this.tabName == 'allPageVisit'){
      this.columns = this.allPageVisitColums;
    } else if(this.tabName == 'soldLeads'){
      this.columns = this.conversionsColumn;
    }
  }
  onFilterChange(value: string) {
    this.pageIndex = 0;
    this.searchedKeyword = value.trim();
    this.router.navigateByUrl(
      `/audience/analytics-list?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );
    this.getTabData();
  }
  pageSizeChange(event: any) {    
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.router.navigateByUrl(
      `/audience/analytics-list?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );
    this.getTabData();
  }
  changeTabName(tabName: string){
    this.tabName = tabName;
    this.router.navigateByUrl(
      `/audience/analytics-list?page=${this.pageIndex + 1
      }${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''}${this.pageSize ? '&size=' + (this.pageSize === 9999 ? 'all' : this.pageSize) : ''}&tabName=${this.tabName}`
    );

  }

  getAnalyticsData() {
    this.apiservice.get(
        `admin/analytic/get-analytic-data?page=${Number(this.pageIndex) + 1
        }&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
        }&startDate=${this.startDate}&endDate=${this.endDate}`
      )
      .subscribe((res: any) => {     
       if (res.body) {
          this.analyticsDetails = res.body;
        }
      });
  }
  getTabData(){
    this.apiservice.get(`admin/analytic/get-tab-data?page=${Number(this.pageIndex) + 1
    }&size=${this.pageSize}${this.searchedKeyword ? '&keywords=' + this.searchedKeyword : ''
    }&startDate=${this.startDate}&endDate=${this.endDate}&tabName=${this.tabName}`).subscribe((res: any)=>{
      if(res.body){
        this.listTitle = res.body?.listTitle;
        if (res.body.data) {
          this.itemList = res.body.data?.data;
          this.totalCount = res.body?.data?.total;
          this.dataSource = new MatTableDataSource(this.itemList);
          this.cdr.detectChanges();
        } else {
          this.itemList = undefined;
        }
      }
      
    })
  }

  dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement){
    this.startDate = moment(this.campaignOne.value.start).format('YYYY-MM-DD HH:mm:ss');
    this.endDate = moment(this.campaignOne.value.end).format('YYYY-MM-DD HH:mm:ss');
    this.getAnalyticsData();
    this.getTabData();
  };

}
